/**
 * Generates a deterministic hash for Excel sheet names to stay within the 31-character limit.
 *
 * @param str The string to hash (typically a column key)
 * @param length The desired length of the hash (default: 15)
 * @returns A base36 hash string of the specified length
 */
export const generateSheetNameHash = (str: string, length = 15): string => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }

  const hashStr = Math.abs(hash).toString(36);
  return hashStr.padStart(length, '0').slice(-length);
};
